import { useId } from "react";

// LogoMark — single SVG source of truth for the brand mark.
// Renders an orange-to-red gradient disc with subtle "nail-head" cross lines
// (top/bottom/left/right notches that stop short of the text) and the
// "nAIl" wordmark inside in JetBrains Mono bold. textLength + lengthAdjust
// guarantee the wordmark always fits inside the disc regardless of size.
//
// IMPORTANT: keep the geometry here in lockstep with
// `scripts/build-brand-assets.mjs` (favicon / PWA icons / OG card).
export default function LogoMark({ size = 44, glow = true }) {
  const uid = useId();
  const gid = `nti-grad-${uid}`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Nail That Interview logo"
      style={{
        flexShrink: 0,
        filter: glow ? `drop-shadow(0 0 ${size * 0.18}px rgba(249,115,22,0.45))` : "none",
      }}
    >
      <defs>
        <linearGradient id={gid} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#f97316" />
          <stop offset="100%" stopColor="#dc2626" />
        </linearGradient>
      </defs>
      <circle cx="50" cy="50" r="48" fill={`url(#${gid})`} />
      <g stroke="rgba(255,255,255,0.62)" strokeWidth="2.4" strokeLinecap="round">
        <line x1="50" y1="2"  x2="50" y2="12" />
        <line x1="50" y1="88" x2="50" y2="98" />
        <line x1="2"  y1="50" x2="6"  y2="50" />
        <line x1="94" y1="50" x2="98" y2="50" />
      </g>
      <text
        x="50"
        y="62"
        textAnchor="middle"
        textLength="77"
        lengthAdjust="spacingAndGlyphs"
        fontFamily="'JetBrains Mono', 'Courier New', Courier, monospace"
        fontWeight="700"
        fontSize="33"
        fill="#ffffff"
      >
        <tspan opacity="0.92">n</tspan>
        <tspan>AI</tspan>
        <tspan opacity="0.92">l</tspan>
      </text>
    </svg>
  );
}
